import { cn } from '../shadcn/lib/utils';

export function Message({ children, className }: { children?: React.ReactNode; className?: string }) {
  return <p className={cn(className, 'my-2')}>{children}</p>;
}
